<template>
    <div>
            <!-- breadcrumb-area -->
            <section class="breadcrumb__area breadcrumb__bg">
 
                <div class="container">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="breadcrumb__content">
                                <h2 class="title text-center">Data Pegawai</h2> 
                            </div>
                        </div>
                    </div>
                </div>
 
            </section>
            <!-- breadcrumb-area-end -->
            <!-- team-area -->
            <section class="team-area pt-10 pb-90">
                <div class="container">
                    <div class="team-item-wrap">
                        <div class="row justify-content-center">
                  
                            <div class="col-xl-3 col-lg-4 col-md-6 col-sm-8" v-for="(data, index) in list_data" :key="index" >
 
                                <div class="team-item">
                                    <div class="team-thumb">
                                        <img :src="$store.state.egov.UPLOADS+data.file" @error="onImageError" alt="Apexa" />
                                        <div class="team-social">
                                            <div class="social-toggle-icon">
                                                <i class="fas fa-share-alt"></i>
                                            </div>

                                            <ul class="list-wrap">
                                                <li>
                                                    <a href="javascript:void(0)"><i class="fab fa-facebook-f"></i></a>
                                                </li>
                                                <li>
                                                    <a href="javascript:void(0)"><i class="fab fa-twitter"></i></a>
                                                </li>
                                                <li>
                                                    <a href="javascript:void(0)"><i class="fab fa-instagram"></i></a>
                                                </li>
                                                <li>
                                                    <a href="javascript:void(0)"><i class="fab fa-pinterest-p"></i></a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="team-content">
                                        <h4 class="title" style="font-size: 15px;"><a href="team-details.html"> {{data.gelar_depan}} {{data.nama}} {{ data.gelar_belakang }} </a></h4>
                                        <span style="font-size: 15px;">{{data.jabatan}}</span>
                                    </div>
                                </div>
                            </div>
                            


                        </div>
                    </div>
                </div>
            </section>
            <!-- team-area-end -->        
    </div>
</template>

<script>
export default {
    data() {
        return {
            list_data:[],
            jml_data:0,
        }
    },
    methods: {
        onImageError(event){
            event.target.src = require('../../../public/assets/img/users.png');
        },
        getView() {
            console.log(this.$store.state.URL.dataPegawai); 
        // Ganti dengan URL API yang sesuai
        fetch(this.$store.state.URL.dataPegawai + 'view', {
            method: "POST",
            headers: {
            "content-type": "application/json", 
            }, 
            body:JSON.stringify(
                {
                data_ke:1,
                cari_value:'', 
            }
            )
        })
        .then(res => res.json())
        .then(res_data => { 
            this.list_data = res_data.data  
            console.log(res_data); 
        });     
        },        
    },
    mounted() {
        this.getView()
        
    },
}
</script>